import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Typography } from '@mui/material'

interface PercentageReturnProps {
  percentageReturn: number
}

// The return beside a vault row's name: an arrow and the percentage, or a dash
// when there is none. Shared by the metal rows and the painting's row.
export default function PercentageReturn({
  percentageReturn
}: Readonly<PercentageReturnProps>): JSX.Element | null {
  if (!percentageReturn) {
    return (
      <Typography variant='body2' color='primary'>
        -
      </Typography>
    )
  }

  if (percentageReturn >= 0) {
    return (
      <Typography
        variant='body2'
        component='div'
        display='flex'
        justifyContent='center'
        alignItems='center'
        color='primary'
      >
        <KeyboardArrowUpIcon sx={{ fontSize: '11px' }} />
        <Typography color='primary' variant='body2'>
          {Number(percentageReturn).toFixed(2)}%
        </Typography>
      </Typography>
    )
  } else if (percentageReturn < 0) {
    return (
      <Typography
        variant='body2'
        component='div'
        display='flex'
        justifyContent='center'
        alignItems='center'
        color='primary'
      >
        <KeyboardArrowDownIcon sx={{ fontSize: '11px' }} />
        <Typography color='primary' variant='body2'>
          {Number(Math.abs(percentageReturn)).toFixed(2)}%
        </Typography>
      </Typography>
    )
  } else {
    return null
  }
}
